import useIsProductListIntersecting from 'components/shared/productList/shared/hooks/useIsProductListIntersecting';
import useIntersectionObserver from 'hooks/globals/useIntersectionObserver';
import useScrollEffect from 'hooks/globals/useScrollEffect';
import { RefObject, useState } from 'react';

export default function useShouldFiltersBeSticky(ref: RefObject<HTMLDivElement>) {
    const filterContainer = useIntersectionObserver(ref, {});
    const isFilterContainerIntersecting = filterContainer?.isIntersecting;
    const isProductListIntersecting = useIsProductListIntersecting();
    const [isScrollingUp, setIsScrollingUp] = useState(false);

    useScrollEffect(({ direction }) => {
        if (direction === 'up') {
            setIsScrollingUp(true);
        } else {
            setIsScrollingUp(false);
        }
    }, []);

    const shouldFiltersBeSticky = isProductListIntersecting && !isFilterContainerIntersecting && isScrollingUp;

    return shouldFiltersBeSticky;
}
